<script setup lang="ts">
type fillTypes = 'light' | 'dark';
interface IIconProps {
  fill?: fillTypes;
}
const props = withDefaults(defineProps<IIconProps>(), {
  fill: 'light',
});
const fillValue = computed(() => {
  return props.fill === 'dark'
    ? 'url(#light-gradient)'
    : props.fill === 'light'
      ? 'url(#dark-gradient)'
      : '#BFBFC8';
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    height="18"
    width="18"
  >
    <path
      d="M8.9625 13.5C9.225 13.5 9.44688 13.4094 9.62813 13.2281C9.80938 13.0469 9.9 12.825 9.9 12.5625C9.9 12.3 9.80938 12.0781 9.62813 11.8969C9.44688 11.7156 9.225 11.625 8.9625 11.625C8.7 11.625 8.47813 11.7156 8.29688 11.8969C8.11563 12.0781 8.025 12.3 8.025 12.5625C8.025 12.825 8.11563 13.0469 8.29688 13.2281C8.47813 13.4094 8.7 13.5 8.9625 13.5ZM9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.48438 12.8375 2.09063 11.925C1.69688 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69688 6.9875 2.09063 6.075C2.48438 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48438 6.075 2.09063C6.9875 1.69688 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69688 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5ZM9.075 5.775C9.3875 5.775 9.65938 5.875 9.89062 6.075C10.1219 6.275 10.2375 6.525 10.2375 6.825C10.2375 7.1 10.1531 7.34375 9.98438 7.55625C9.81563 7.76875 9.625 7.96875 9.4125 8.15625C9.125 8.40625 8.87188 8.68125 8.65313 8.98125C8.43438 9.28125 8.325 9.61875 8.325 9.99375C8.325 10.1688 8.39063 10.3156 8.52188 10.4344C8.65313 10.5531 8.80625 10.6125 8.98125 10.6125C9.16875 10.6125 9.32813 10.55 9.45938 10.425C9.59063 10.3 9.675 10.1438 9.7125 9.95625C9.7625 9.69375 9.875 9.45938 10.05 9.25313C10.225 9.04688 10.4125 8.85 10.6125 8.6625C10.9 8.3875 11.1469 8.0875 11.3531 7.7625C11.5594 7.4375 11.6625 7.075 11.6625 6.675C11.6625 6.0375 11.4031 5.51562 10.8844 5.10938C10.3656 4.70313 9.7625 4.5 9.075 4.5C8.6 4.5 8.14688 4.6 7.71563 4.8C7.28438 5 6.95625 5.30625 6.73125 5.71875C6.64375 5.86875 6.61563 6.02813 6.64688 6.19688C6.67813 6.36563 6.7625 6.49375 6.9 6.58125C7.075 6.68125 7.25625 6.7125 7.44375 6.675C7.63125 6.6375 7.7875 6.53125 7.9125 6.35625C8.05 6.16875 8.22188 6.025 8.42813 5.925C8.63438 5.825 8.85 5.775 9.075 5.775Z"
      :fill="fillValue"
    />
    <defs>
      <linearGradient
        id="light-gradient"
        x1="9.99999"
        y1="1.66602"
        x2="9.99999"
        y2="18.3327"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F8F8F9" />
        <stop offset="1" stop-color="#C5C6CE" />
      </linearGradient>
      <linearGradient
        id="dark-gradient"
        x1="12"
        y1="2"
        x2="12"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6A6B7C" />
        <stop offset="1" stop-color="#2F2F37" />
      </linearGradient>
    </defs>
  </svg>
</template>
<style scoped></style>
